import { useCallback } from 'react';
import { Box, Tab, TabList, Tabs } from '~/commonComponents';
import { OnsiteInterviewStatus, OnsiteInterviewStatusMapper } from '~/domain/PermanentJobs';

const TABS = [
  OnsiteInterviewStatus.ActionNeeded,
  OnsiteInterviewStatus.Open,
  OnsiteInterviewStatus.Scheduled,
  OnsiteInterviewStatus.Completed,
  OnsiteInterviewStatus.Cancelled,
];

interface IOnsiteInterviewStatusFilterPanelProps {
  counts: Record<OnsiteInterviewStatus, number> & { all: number };
  onChange(tab: OnsiteInterviewStatus | 'all'): void;
}

export const OnsiteInterviewStatusFilterPanel = ({
  counts,
  onChange,
}: IOnsiteInterviewStatusFilterPanelProps) => {
  const handleTabChange = useCallback(
    (idx: number) => {
      onChange(TABS[idx - 1] || 'all');
    },
    [onChange],
  );

  return (
    <Tabs
      tabListStyle={{ gap: 16 }}
      style={{ alignItems: 'flex-start' }}
      onChangeTab={handleTabChange}
    >
      <TabList>
        <Tab
          dataCy="onsite-interview-filter-tab-all"
          title={`All Active${counts.all > 0 ? ` (${counts.all})` : ''}`}
          textStyle={{
            fontSize: 20,
          }}
        />
        {TABS.map((it) => (
          <Tab
            dataCy={`onsite-interview-filter-tab-${it}`}
            PrefixComponent={
              <Box
                backgroundColor={OnsiteInterviewStatusMapper.getColor(it)}
                borderRadius="100%"
                height={10}
                width={10}
              />
            }
            key={it}
            title={`${OnsiteInterviewStatusMapper.toHumanReadable(it)}${counts[it] > 0 ? ` (${counts[it]})` : ''}`}
            textStyle={{
              fontSize: 20,
            }}
          />
        ))}
      </TabList>
    </Tabs>
  );
};
